module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('z-basePage', {
    attrs: {
      "title": _vm.bu_title,
      "pop": true
    }
  }, [_c('div', {
    ref: "tabTitle",
    attrs: {
      "slot": "tab-title"
    },
    slot: "tab-title"
  }, [_c('div', {
    class: {
      active: _vm.activeIndex == 0
    },
    on: {
      "click": function($event) {
        _vm.chenageTab(0)
      }
    }
  }, [_vm._v("职员信息")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tab_judge),
      expression: "tab_judge"
    }],
    class: {
      active: _vm.activeIndex == 1
    },
    on: {
      "click": function($event) {
        _vm.chenageTab(1)
      }
    }
  }, [_vm._v("BU信息")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tab_judge),
      expression: "tab_judge"
    }],
    class: {
      active: _vm.activeIndex == 2
    },
    on: {
      "click": function($event) {
        _vm.chenageTab(2)
      }
    }
  }, [_vm._v("奖金明细")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tab_judge),
      expression: "tab_judge"
    }],
    class: {
      active: _vm.activeIndex == 3
    },
    on: {
      "click": function($event) {
        _vm.chenageTab(3)
      }
    }
  }, [_vm._v("职级明细")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tab_judge),
      expression: "tab_judge"
    }],
    class: {
      active: _vm.activeIndex == 4
    },
    on: {
      "click": function($event) {
        _vm.chenageTab(4)
      }
    }
  }, [_vm._v("预算明细")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tab_judge),
      expression: "tab_judge"
    }],
    class: {
      active: _vm.activeIndex == 5
    },
    on: {
      "click": function($event) {
        _vm.chenageTab(5)
      }
    }
  }, [_vm._v("罚单明细")])]), _vm._v(" "), _c('div', {
    ref: "tabMain",
    staticClass: "tab-wrap"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeIndex == 0),
      expression: "activeIndex == 0"
    }]
  }, [_c('div', {
    staticClass: "btns-top"
  }, [(_vm.bu_type == 10) ? _c('div', {
    staticClass: "back-btn red",
    on: {
      "click": function($event) {
        _vm.quit()
      }
    }
  }, [_vm._v("离职")]) : _vm._e(), _vm._v(" "), (_vm.tab_judge) ? _c('div', {
    staticClass: "back-btn blue",
    on: {
      "click": _vm.addPerson
    }
  }, [_vm._v("添加")]) : _vm._e(), _vm._v(" "), (_vm.tab_judge) ? _c('div', {
    staticClass: "back-btn red",
    class: {
      disabled: _vm.deleteIds.length == 0
    },
    on: {
      "click": function($event) {
        _vm.removePerson()
      }
    }
  }, [_vm._v("移除")]) : _vm._e(), _vm._v(" "), (_vm.tab_judge) ? _c('div', {
    staticClass: "back-btn blue",
    on: {
      "click": function($event) {
        _vm.changeManager(_vm.manager_id)
      }
    }
  }, [_vm._v("合伙人设置")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "back-list"
  }, [_c('div', {
    staticClass: "list-head"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.bu_type != 20),
      expression: "bu_type != 20"
    }]
  }, [_c('el-checkbox', {
    attrs: {
      "disabled": _vm.maxIds.length == 0
    },
    on: {
      "change": _vm.checkList
    },
    model: {
      value: (_vm.checkall),
      callback: function($$v) {
        _vm.checkall = $$v
      },
      expression: "checkall"
    }
  })], 1), _vm._v(" "), _c('div', [_vm._v("工号")]), _vm._v(" "), _c('div', [_vm._v("姓名")]), _vm._v(" "), _c('div', [_vm._v("职称")]), _vm._v(" "), _c('div', [_vm._v("岗位")]), _vm._v(" "), _c('div', [_vm._v("职级")]), _vm._v(" "), _c('div', [_vm._v("年资")]), _vm._v(" "), _c('div', [_vm._v("生日")]), _vm._v(" "), (_vm.bu_type != 20) ? _c('div', [_vm._v("操作")]) : _vm._e()]), _vm._v(" "), _c('z-scrollDiv', [_vm._l((_vm.dataList), function(item) {
    return _c('el-checkbox-group', {
      key: item.id,
      staticClass: "list-item",
      model: {
        value: (_vm.deleteIds),
        callback: function($$v) {
          _vm.deleteIds = $$v
        },
        expression: "deleteIds"
      }
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.bu_type != 20),
        expression: "bu_type != 20"
      }]
    }, [_c('el-checkbox', {
      attrs: {
        "label": item.id,
        "disabled": _vm.tab_judge && item.bu_identity_type == 1
      },
      on: {
        "change": _vm.changeCheck
      }
    }, [_vm._v(_vm._s(""))])], 1), _vm._v(" "), _c('div', [_vm._v(_vm._s(item.user_name))]), _vm._v(" "), _c('div', {
      staticClass: "overhide"
    }, [_c('span', {
      staticClass: "name",
      on: {
        "click": function($event) {
          _vm.showPerson(item.id)
        }
      }
    }, [_vm._v(_vm._s(_vm._f("placeholder")(item.real_name)))])]), _vm._v(" "), _c('div', {
      staticClass: "overhide"
    }, [_vm._v(_vm._s(item.bu_identity_type == 1 ? "合伙人" : "职员"))]), _vm._v(" "), _c('div', {
      staticClass: "overhide"
    }, [_vm._v(_vm._s(_vm._f("placeholder")(item.position_name)))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(((item.grade) + "级")))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(((item.work_year) + "年")))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm._f("placeholder")(_vm._f("justDate")(item.birthday))))]), _vm._v(" "), (_vm.bu_type != 20) ? _c('div', [(_vm.bu_type == 10) ? _c('span', {
      staticClass: "red",
      on: {
        "click": function($event) {
          _vm.quit(item.id)
        }
      }
    }, [_vm._v("离职")]) : _vm._e(), _vm._v(" "), (_vm.tab_judge && item.bu_identity_type == 1) ? _c('span', {
      on: {
        "click": function($event) {
          _vm.cancelManager(item.id)
        }
      }
    }, [_vm._v("取消合伙人")]) : _vm._e(), _vm._v(" "), (_vm.tab_judge && item.bu_identity_type == 2) ? _c('span', {
      staticClass: "red",
      on: {
        "click": function($event) {
          _vm.removePerson(item.id)
        }
      }
    }, [_vm._v("移除")]) : _vm._e()]) : _vm._e()])
  }), _vm._v(" "), _c('z-noData', {
    attrs: {
      "list": _vm.dataList
    }
  })], 2)], 1)]), _vm._v(" "), _c('info', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeIndex == 1 && _vm.tab_judge),
      expression: "activeIndex==1 && tab_judge"
    }],
    attrs: {
      "index": _vm.activeIndex,
      "buId": _vm.buId
    }
  }), _vm._v(" "), _c('asset', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeIndex == 2 && _vm.tab_judge),
      expression: "activeIndex == 2 && tab_judge"
    }],
    attrs: {
      "index": _vm.activeIndex,
      "buId": _vm.buId
    }
  }), _vm._v(" "), _c('rank', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeIndex == 3 && _vm.tab_judge),
      expression: "activeIndex == 3 && tab_judge"
    }],
    attrs: {
      "index": _vm.activeIndex,
      "buId": _vm.buId
    }
  }), _vm._v(" "), _c('budget', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeIndex == 4 && _vm.tab_judge),
      expression: "activeIndex == 4 && tab_judge"
    }],
    attrs: {
      "index": _vm.activeIndex,
      "buId": _vm.buId
    }
  }), _vm._v(" "), _c('ticket', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeIndex == 5 && _vm.tab_judge),
      expression: "activeIndex == 5 && tab_judge"
    }],
    attrs: {
      "index": _vm.activeIndex,
      "buId": _vm.buId
    }
  })], 1), _vm._v(" "), _c('z-windowPop', {
    attrs: {
      "show": _vm.pop.show,
      "title": (_vm.bu_title + "合伙人变更"),
      "btnshow": _vm.pop.btnFlag,
      "savetext": _vm.btnText
    },
    on: {
      "confirm": _vm.changeLeader,
      "cancel": _vm.closeLeader
    }
  }, [_c('div', {
    staticClass: "back-item pop-main"
  }, [_c('div', {
    staticClass: "back-title"
  }, [_vm._v("新BU合伙人")]), _vm._v(" "), _c('div', {
    staticClass: "back-wrap"
  }, [_c('el-select', {
    staticClass: "top-choose",
    on: {
      "change": _vm.changePartner
    },
    model: {
      value: (_vm.pop.userId),
      callback: function($$v) {
        _vm.$set(_vm.pop, "userId", $$v)
      },
      expression: "pop.userId"
    }
  }, _vm._l((_vm.pop.userOptions), function(group, key) {
    return _c('el-option-group', {
      key: key,
      attrs: {
        "label": _vm._f("trans")(key)
      }
    }, _vm._l((group), function(item) {
      return _c('el-option', {
        key: item.id,
        attrs: {
          "label": item.real_name,
          "value": item.id
        }
      })
    }))
  }))], 1)])]), _vm._v(" "), _c('z-windowPop', {
    attrs: {
      "show": _vm.pop.user_show,
      "title": "BU成员选择",
      "btnshow": _vm.pop.user_ids.length > 0,
      "savetext": "确定"
    },
    on: {
      "confirm": _vm.addMembers,
      "cancel": _vm.closeUser
    }
  }, [_c('div', {
    staticClass: "member-wrap"
  }, [_c('member', {
    attrs: {
      "list": _vm.pop.user_list,
      "cancel": _vm.pop.cancel_flag
    },
    on: {
      "change": _vm.getMemberIds,
      "cancel": function($event) {
        _vm.pop.cancel_flag = false
      }
    }
  })], 1)]), _vm._v(" "), _c('personPop', {
    attrs: {
      "id": _vm.person.id,
      "show": _vm.person.flag
    },
    on: {
      "infoChange": function($event) {
        _vm.fresh()
      },
      "close": function($event) {
        _vm.person.flag = false
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@10.3.0@vue-loader/lib/template-compiler.js?id=data-v-1efa88e7!./~/_vue-loader@10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/views/backEndStage/person/page-bu-detail.vue
// module id = 707
// module chunks = 1